// src/habits.js
// ─────────────────────────────────────────────────────────────
//  EDIT THIS FILE to customize your habits
//  - name: what shows in the tracker
//  - goal: how many days per month you want to hit this habit
//  - color: accent color for this habit row (any CSS color)
//  - icon: any emoji
// ─────────────────────────────────────────────────────────────

export const HABITS = [
  { id: "plan_day",        name: "Plan my day",            goal: 24, icon: "📋", color: "#7C3AED" },
  { id: "stretch",         name: "Stretch for 10 mins",    goal: 20, icon: "🧘", color: "#0891B2" },
  { id: "water",           name: "Drink 2.5L of water",    goal: 22, icon: "💧", color: "#2563EB" },
  { id: "study",           name: "Study for 30 mins",      goal: 20, icon: "📚", color: "#059669" },
  { id: "strength",        name: "Strength training",      goal: 15, icon: "🏋️", color: "#DC2626" },
  { id: "cardio",          name: "Cardio training",        goal: 15, icon: "🏃", color: "#EA580C" },
  { id: "family",          name: "Spend time with family", goal: 22, icon: "👨‍👩‍👧", color: "#D97706" },
  { id: "clean",           name: "Clean and organize",     goal: 15, icon: "✨", color: "#65A30D" },
  { id: "plants",          name: "Water the plants",       goal: 15, icon: "🌱", color: "#16A34A" },
  { id: "puppy",           name: "Train puppy",            goal: 20, icon: "🐶", color: "#CA8A04" },
  { id: "mindfulness",     name: "Practice mindfulness",   goal: 12, icon: "🧠", color: "#9333EA" },
  { id: "breathing",       name: "Breathing exercises",    goal: 22, icon: "🌬️", color: "#0284C7" },
  { id: "walk",            name: "Go for a walk",          goal: 6,  icon: "🚶", color: "#15803D" },
  { id: "no_outside_food", name: "No outside food",        goal: 22, icon: "🥗", color: "#B45309" },
];
